<template>
  <div class="cpt-countdown-container" v-if="seconds > 0">
    <div class="countdown">
      <template v-if="getTimeNumber('day') !== '00'">
        <div class="block">
          <span :style="fontColor">{{ getTimeNumber('day') }}</span>
        </div>
        <div class="day" :style="fontColor">天</div>
      </template>
      <div class="block">
        <span :style="fontColor"
          >{{ getTimeNumber('hour', 0) }}{{ getTimeNumber('hour', 1) }}</span
        >
      </div>
      <div class="ch" :style="fontColor">:</div>
      <div class="block">
        <span :style="fontColor"
          >{{ getTimeNumber('minute', 0)
          }}{{ getTimeNumber('minute', 1) }}</span
        >
      </div>
      <div class="ch" :style="fontColor">:</div>
      <div class="block">
        <span :style="fontColor"
          >{{ getTimeNumber('second', 0)
          }}{{ getTimeNumber('second', 1) }}</span
        >
      </div>
    </div>
    <p class="countdown-desc">开奖倒计时</p>
  </div>
</template>

<script>
export default {
  name: 'cpt-countdown',
  props: {
    fontColor: {
      type: String,
      default: '#000',
    },
    endTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      timestamp: Math.floor(new Date().getTime() / 1000),
      seconds: 0,
      timer: null,
    };
  },
  watch: {
    interval() {
      this.seconds = this.interval;
    },
  },
  computed: {
    interval() {
      return (
        Math.floor(new Date(this.endTime).getTime() / 1000) - this.timestamp
      );
    },
  },
  mounted() {
    this.initialCountDown();
  },
  methods: {
    getTimeNumber(type, index) {
      var seconds = this.seconds % 60;
      var minutes = Math.floor(this.seconds / 60) % 60;
      var hours = Math.floor(Math.floor(this.seconds / 60) / 60) % 24;
      var days = Math.floor(
        Math.floor(Math.floor(this.seconds / 60) / 60) / 24,
      );
      var num = 0;
      switch (type) {
        case 'day':
          num = ('' + days).length === 1 ? '0' + days : days;
          break;
        case 'hour':
          if (index == 1) {
            num = hours % 10;
          } else if (index == 0) {
            num = Math.floor(hours / 10);
          }
          break;
        case 'minute':
          if (index == 1) {
            num = minutes % 10;
          } else if (index == 0) {
            num = Math.floor(minutes / 10);
          }
          break;
        case 'second':
          if (index == 1) {
            num = seconds % 10;
          } else if (index == 0) {
            num = Math.floor(seconds / 10);
          }
      }
      return num;
    },
    initialCountDown() {
      clearInterval(this.timer);
      this.seconds = this.interval;
      this.timer = setInterval(() => {
        this.seconds--;
        if (this.seconds == 0) {
          clearInterval(this.timer);
          this.$emit('refresh');
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less">
@import '../assets/font/ALIBABA-Bold.css';

.cpt-countdown-container {
  text-align: center;
  .countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      text-align: center;
      &.day {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        margin: 0 7px;
      }
      &.block {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 54px;
        height: 58px;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.3);
        > span {
          font-family: ALIBABA-Font;
          font-size: 36px;
          line-height: 43px;
        }
      }
      &.ch {
        font-size: 32px;
        line-height: 45px;
        margin: 0 7px;
      }
    }
  }
  .countdown-desc {
    color: rgba(0, 0, 0, 0.4);
    font-size: 10px;
    line-height: 14px;
    margin-top: 4px;
  }
}
</style>
